module.exports = __webpack_public_path__ + "static/media/dashboard_wireframe.fe53149f.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/lifedash/src/dashboard_wireframe.png
// module id = 212
// module chunks = 0